export default __webpack_public_path__ + "static/media/logoutIcon.a4b5f6bf.svg";